import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import { contentCardSx } from '../../../../styles/standaloneLayoutTokens';

function formatDateLabel(dateStr) {
  const [, m, d] = dateStr.split('-');
  return `${parseInt(m, 10)}/${parseInt(d, 10)}`;
}

export default function WaitTimeChart({ data }) {
  const theme = useTheme();

  if (!data || data.length === 0) return null;

  const filtered = data.filter(d => d.avgWait !== null);
  if (filtered.length === 0) return null;

  return (
    <Paper elevation={0} sx={{ ...contentCardSx, p: 2.5 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
        Average Wait Time (minutes)
      </Typography>

      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={filtered} margin={{ top: 4, right: 8, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            dataKey="date"
            tickFormatter={formatDateLabel}
            tick={{ fontSize: 12 }}
            stroke={theme.palette.text.secondary}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 12 }}
            stroke={theme.palette.text.secondary}
            unit=" min"
          />
          <Tooltip
            labelFormatter={formatDateLabel}
            formatter={(value) => [`${value} min`, 'Avg Wait']}
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 8,
            }}
          />
          <Line
            type="monotone"
            dataKey="avgWait"
            name="Avg Wait"
            stroke={theme.palette.warning.main}
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
}
